import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface Credentials {
  userId: string;
  secret: string;
}

interface CredentialsContextType {
  credentials: Credentials;
  setCredentials: (creds: Credentials) => void;
}

const CredentialsContext = createContext<CredentialsContextType | undefined>(undefined);

export const useCredentials = () => {
  const context = useContext(CredentialsContext);
  if (!context) throw new Error('useCredentials must be used within CredentialsProvider');
  return context;
};

export const CredentialsProvider = ({ children }: { children: ReactNode }) => {
  const [credentials, setCredentials] = useState<Credentials>({ userId: '', secret: '' });
  return (
    <CredentialsContext.Provider value={{ credentials, setCredentials }}>
      {children}
    </CredentialsContext.Provider>
  );
};
